/**
 * @module modules/mask
 * @requires module:common/config/mask-configs
 */
import IMask from 'imask';
import MaskConfigs from '@/common/config/mask-configs';
/**
  * @classdesc Модуль маски для полей ввода
  */
class Mask {
  /**
    * @description Добавляет маску на поле ввода
    * @param {HTMLElement|HTMLInputElement} el - Поле ввода, для которого добавляется маска
    * @param {String} maskName - Имя маски
    */
  static maskInput(el, maskName) {
    const inputElement = el instanceof HTMLInputElement ? el : el.querySelector('input');
    IMask(inputElement, MaskConfigs[maskName]);
  }
}
 
export default Mask;